/** @jsxRuntime classic */
/** @jsx jsx */
import React, { useEffect, useState } from 'react'
import { jsx } from "@emotion/core";
import Select from 'react-select';
import { useSelector, useDispatch } from 'react-redux';
import { pushToSetting } from '../../redux/slices/SettingSclice';
import { setSetting } from '../action/common';
import CollapseExpandAll from './CollapseExpandAll';

const GroupByDropdown = React.memo(({collapseExpandAll = true}) => {
    const { settings } = useSelector(state => state.settings)
    const { colorPicker, colorPickerDark, theme } = useSelector(state => state.theme);
    const dispatch = useDispatch()
    // const [options, setOptions] = useState([{value: 'none', label: 'List'}, {value: 'project', label: 'Project'}, {value: 'calendar', label: 'Calendar'}])
    const [options, setOptions] = useState([{value: 'none', label: 'List'}, {value: 'project', label: 'Project'}])

    const selectGroupBy = ({value}) => {
        const newSettings = { ...settings, groupBy: value };
        dispatch(pushToSetting(newSettings))
        setSetting({ settings: newSettings });
    }

    function generateSvgDataUrl(strokeColor) {
        const svg = `
            <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.5">
                    <path d="M5.25 8.6665H2.33333C2.01117 8.6665 1.75 8.92767 1.75 9.24984V12.1665C1.75 12.4887 2.01117 12.7498 2.33333 12.7498H5.25C5.57217 12.7498 5.83333 12.4887 5.83333 12.1665V9.24984C5.83333 8.92767 5.57217 8.6665 5.25 8.6665Z" stroke="${strokeColor}" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5.25 8.6665H2.33333C2.01117 8.6665 1.75 8.92767 1.75 9.24984V12.1665C1.75 12.4887 2.01117 12.7498 2.33333 12.7498H5.25C5.57217 12.7498 5.83333 12.4887 5.83333 12.1665V9.24984C5.83333 8.92767 5.57217 8.6665 5.25 8.6665Z" stroke="black" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5.25 2.25H2.33333C2.01117 2.25 1.75 2.51117 1.75 2.83333V5.75C1.75 6.07217 2.01117 6.33333 2.33333 6.33333H5.25C5.57217 6.33333 5.83333 6.07217 5.83333 5.75V2.83333C5.83333 2.51117 5.57217 2.25 5.25 2.25Z" stroke="${strokeColor}" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5.25 2.25H2.33333C2.01117 2.25 1.75 2.51117 1.75 2.83333V5.75C1.75 6.07217 2.01117 6.33333 2.33333 6.33333H5.25C5.57217 6.33333 5.83333 6.07217 5.83333 5.75V2.83333C5.83333 2.51117 5.57217 2.25 5.25 2.25Z" stroke="black" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8.16675 2.8335H12.2501" stroke="${strokeColor}" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8.16675 2.8335H12.2501" stroke="black" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8.16675 5.75H12.2501" stroke="${strokeColor}" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8.16675 5.75H12.2501" stroke="black" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8.16675 9.25H12.2501" stroke="${strokeColor}" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8.16675 9.25H12.2501" stroke="black" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8.16675 12.1665H12.2501" stroke="${strokeColor}" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8.16675 12.1665H12.2501" stroke="black" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
            </svg>`;
      
        const encoded = encodeURIComponent(svg)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
      
        return `url("data:image/svg+xml,${encoded}")`;
    }
    
    // useEffect(() => {
    //     if(!settings?.google_access_token){
    //         setOptions(options.filter(option => option.value !== 'calendar'))
    //     }
    // }, [settings])

    return (
        <div className="flex items-center" css={{
            '.groups-dropdown':{
                '&:before': {
                    backgroundImage: generateSvgDataUrl(theme == "dark" ? colorPickerDark : colorPicker),
                }
            }
        }}>
            <Select 
                onChange={selectGroupBy}
                options={options}
                value={options.filter(option => option.value === settings?.groupBy)?.[0] ?? options[0]}
                className="react-select groups-dropdown"
                classNames={{control: () => 'groups-dropdown-control', singleValue: () => 'dark:text-white2 mt-[2px] text-sm', option: (e) => {
                    let c = 'text-black dark:text-white';
                    if(e.isSelected){
                        c += ' !darkmode-background text-white'
                    }else{
                        c += ' bg-white dark:bg-black';
                    }
                    return c;
                }}}
            />
            {collapseExpandAll && settings?.groupBy == 'project' && <CollapseExpandAll />}
        </div>
    )
})

export default GroupByDropdown